import { code } from "@spscommerce/utils";

export const SpsCheckboxExamples = {
    labels: {
        label: "Labels",
        description: code`
            <p>An individual checkbox should be labeled with its own <code>label</code> prop,
            not the <code>&lt;sps-label&gt;</code> component.</p>
        `,
        examples: {
            label: {
                template: code`
                    <form [formGroup]="form">
                        <sps-checkbox value="red" label="Red" formControlName="red" id="labelCheckboxExample">
                        </sps-checkbox>
                        <sps-checkbox value="blue" label="Blue" formControlName="blue">
                        </sps-checkbox>
                        <sps-checkbox value="green" label="Green" formControlName="green" indeterminate>
                        </sps-checkbox>
                    </form>
                `,
                class: code`
                class DemoComponent implements OnInit {
                    constructor(private _formBuilder: FormBuilder) {}
                    form: FormGroup;
                    ngOnInit() {
                      this.form = this._formBuilder.group({
                          red: [true],
                          blue: [false],
                          green: [""]
                      });
                    }
                  }
                `
            }
        }
    },
    disabled: {
        label: "Disabled",
        examples: {
            disabled: {
                template: code`
                    <form [formGroup]="form">
                        <sps-checkbox value="red" label="Red" formControlName="red" id="disabledCheckboxExample">
                        </sps-checkbox>
                        <sps-checkbox value="blue" label="Blue" formControlName="blue">
                        </sps-checkbox>
                        <sps-checkbox value="green" label="Green" formControlName="green" indeterminate>
                        </sps-checkbox>
                    </form>
                `,
                class: code`
                    class DemoComponent implements OnInit {
                        constructor(private _formBuilder: FormBuilder) {}
                        form: FormGroup;
                        ngOnInit() {
                            this.form = this._formBuilder.group({
                                red:[{value:true,disabled:true}],
                                blue: [{value:false,disabled:true}],
                                green:[{value:"",disabled:true}]
                            });
                        }
                    }
                `
            }
        }
    },
    noLabels: {
        label: "No Label",
        description: code`
            <p>Checkboxes without labels are used in table rows and Summary List Rows
            to allow those rows to be selected and deselected. They are not normally
            used elsewhere and doing so should be done with utmost caution. Any checkbox
            without a label should visually have an obvious purpose and should always have
            an <code>aria-label</code> describing what it's for to screen reader users.</p>
        `,
        examples: {
            noLabels: {
                template: code`
                    <sps-summary-list-row [selected]="exampleIsSelected">
                        <sps-summary-list-col width="2.875rem" lean>
                            <sps-checkbox aria-label="Row Selected" [(ngModel)]="exampleIsSelected"></sps-checkbox>
                        </sps-summary-list-col>
                        <sps-summary-list-col>
                            <i aria-label="Error" class="sps-icon sps-icon--lg sps-icon-status-error align-middle mr-2 pr-1"></i>
                            <div class="d-inline-block align-middle">
                            <div class="fs-18 lh-24"><a href="#">Heading</a></div>
                            <div class="fs-14 lh-20">Sub Heading</div>
                            </div>
                        </sps-summary-list-col>
                    </sps-summary-list-row>
                `,
                class: code`
                    class DemoComponent {
                        exampleIsSelected = true;
                    }
                `
            }
        }
    }
};
